module.exports = __webpack_public_path__ + "img/sabre.2e0088d9.png";